export const THEME_IDS = {
  light: 'light',
  proDark: 'dark',
  dracula: 'dracula',
  softLight: 'soft-light',
  orangeSlate: 'orange-slate',
  redSlate: 'red-slate',
  greenSlate: 'green-slate',
  okGreenSlate: 'okgreen-slate',
  okGreenDarkSlate: 'okgreen-dark-slate',
  goldDarkSlate: 'gold-dark-slate',
  whiteRed: 'white-red',
  coralSlate: 'coral-slate',
  orangeDarkSlate: 'orange-dark-slate',
  orangeLightSlate: 'orange-light-slate',
  lightOrange: 'light-orange',
  navySlate: 'navy-slate',
  orangeEmeraldDark: 'orange-emerald-dark',
  indigoSlate: 'indigo-slate',
  frostSlate: 'frost-slate',
  lightGraySlate: 'light-gray-slate',
  deepGreen: 'deep-green',
  whiteSlate: 'white-slate',
  electricGoldDarkSlate: 'electric-gold-dark-slate',
  goldLightSlate: 'gold-light-slate',
  emeraldLightSlate: 'emerald-light-slate',
  lobbyBlack: 'lobby-black',
};

export const THEMES = [
  { id: THEME_IDS.light, label: 'Light' },
  { id: THEME_IDS.proDark, label: 'Pro Dark' },
  { id: THEME_IDS.dracula, label: 'Dracula' },
  { id: THEME_IDS.softLight, label: 'Soft Light' },
  { id: THEME_IDS.orangeSlate, label: 'Orange Slate' },
  { id: THEME_IDS.redSlate, label: 'Red Slate' },
  { id: THEME_IDS.greenSlate, label: 'Green Slate' },
  { id: THEME_IDS.okGreenSlate, label: 'OK Green Slate' },
  { id: THEME_IDS.okGreenDarkSlate, label: 'OK Green Dark Slate' },
  { id: THEME_IDS.goldDarkSlate, label: 'Gold Dark Slate' },
  { id: THEME_IDS.whiteRed, label: 'White Red' },
  { id: THEME_IDS.coralSlate, label: 'Coral Slate' },
  { id: THEME_IDS.orangeDarkSlate, label: 'Orange Dark Slate' },
  { id: THEME_IDS.orangeLightSlate, label: 'Orange Light Slate' },
  { id: THEME_IDS.lightOrange, label: 'Light Orange' },
  { id: THEME_IDS.navySlate, label: 'Navy Slate' },
  { id: THEME_IDS.orangeEmeraldDark, label: 'Orange Emerald Dark' },
  { id: THEME_IDS.indigoSlate, label: 'Indigo Slate' },
  { id: THEME_IDS.frostSlate, label: 'Frost Slate' },
  { id: THEME_IDS.lightGraySlate, label: 'Light Gray Slate' },
  { id: THEME_IDS.deepGreen, label: 'Deep Green' },
  { id: THEME_IDS.whiteSlate, label: 'White Slate' },
  { id: THEME_IDS.electricGoldDarkSlate, label: 'Electric Gold Dark Slate' },
  { id: THEME_IDS.goldLightSlate, label: 'Gold Light Slate' },
  { id: THEME_IDS.emeraldLightSlate, label: 'Emerald Light Slate' },
  { id: THEME_IDS.lobbyBlack, label: 'Lobby Black' },
];

export const normalizeTheme = (key) => {
  if (!key) return THEME_IDS.light;
  return (THEMES.some((t) => t.id === key) ? key : THEME_IDS.light);
};

const DARK_THEME_IDS = new Set([
  THEME_IDS.proDark,
  THEME_IDS.dracula,
  THEME_IDS.goldDarkSlate,
  THEME_IDS.orangeDarkSlate,
  THEME_IDS.orangeEmeraldDark,
  THEME_IDS.deepGreen,
  THEME_IDS.electricGoldDarkSlate,
  THEME_IDS.okGreenDarkSlate,
  THEME_IDS.lobbyBlack,
  'dark',
]);

export const isDarkTheme = (themeId) =>
  themeId && DARK_THEME_IDS.has(String(themeId).toLowerCase());

export const getPortalThemeProps = (fromEl) => {
  const root = fromEl?.closest?.('.keobongvip-root');
  const theme = root?.getAttribute('data-theme') || undefined;
  const className = [
    'keobongvip-root',
    theme,
    root?.classList.contains('dark') ? 'dark' : null,
  ]
    .filter(Boolean)
    .join(' ');
  return { theme, className };
};

export const defaultTheme = THEME_IDS.light;
